import TrainMap from './TrainMap';

export default TrainMap;
